import styled, { css } from "styled-components";
import { Col, Collapse, Menu } from "antd";
import {
  BORDER_RADIUS,
  FONT_SIZE,
  FONT_WEIGHT,
  LAYOUT,
  media,
} from "config/theme/constants";
import { BurgerIcon } from "components/common/BurgerIcon/BurgerIcon";

export const DropdownMenu = styled(Menu)`
  line-height: 1.5715;

  border-radius: ${BORDER_RADIUS};

  &.ant-dropdown-menu {
    box-shadow: var(--box-shadow);
  }

  &.ant-dropdown-menu > .ant-dropdown-menu-item {
    padding: 5px 5px;
  }
`;

export const HeaderActionWrapper = styled.div`
  cursor: pointer;

  .ant-btn-icon > span[role="img"],
  .ant-badge > span[role="img"] {
    font-size: ${FONT_SIZE.xl};

    @media only screen and ${media.md} {
      font-size: ${FONT_SIZE.xxxl};
    }
  }

  & .ant-badge {
    display: inline-block;
  }
`;

export const DropdownCollapse = styled(Collapse)`
  & > .ant-collapse-item > .ant-collapse-header {
    font-weight: ${FONT_WEIGHT.semibold};
    font-size: ${FONT_SIZE.xs};

    color: var(--primary-color);

    @media only screen and ${media.md} {
      font-size: ${FONT_SIZE.md};
    }
  }

  & > .ant-collapse-item-disabled > .ant-collapse-header {
    cursor: default;

    & > span[role="img"] {
      display: none;
    }
  }
`;

export const BurgerCol = styled(Col)`
  z-index: 999;
  display: flex;
`;

export const MobileBurger = styled(BurgerIcon)`
  width: 1.75rem;
  height: 1.75rem;
  margin-right: -0.5rem;
  color: var(--text-main-color);
`;

interface ProfileColumnType {
  $isTwoColumnsLayout: boolean;
}

export const ProfileColumn = styled(Col)<ProfileColumnType>`
  @media only screen and ${media.md} {
    ${(props) =>
      props?.$isTwoColumnsLayout &&
      css`
        background-color: var(--sider-background-color);
        padding: ${LAYOUT.desktop.paddingVertical}
          ${LAYOUT.desktop.paddingHorizontal} !important;
      `}
  }
`;
